import { FormattedUserAclWithLicenseInfo } from 'common/services/api/UserProfileAcls/UserProfileAclsThunkTypeDefs';
import { License } from 'common/types/Entities';

/**
 * Finds the associated license in a list of licenses based on the ACL's licenseId.
 *
 * @param {object} acl - An Access Control List object with licenseId.
 * @param {License[]} licenses - An array of License objects.
 * @returns {License | undefined} The matching License object, or undefined if not found.
 */
export const getAssociatedLicense = (acl?: { licenseId?: string }, licenses?: License[]) => {
    if (!acl || !licenses) return;

    for (const license of licenses) {
        if (acl.licenseId === license.id) {
            return license;
        }
    }
};

/**
 * Finds the licenses associated to a specific user from two lists intersection .
 *
 * @param {License[]} licenses    - An array of License objects associated with specific tenant.
 * @param {object} userAclEntries - An array of Acl Entries with license info objects associated with specific user.
 * @returns {License[] | []} The list of matching License objects, or empty list if not found.
 */
export const getUserAssociatedLicenses = (licenses: License[] = [], userAclEntries: FormattedUserAclWithLicenseInfo[] = []) => {
    if(!licenses || !userAclEntries) return [];

    const aclEntriesLicenseIds = new Set(userAclEntries.map(formatAclDataToLicenseId));
    return licenses.filter(x => aclEntriesLicenseIds.has(x.id));
};

function formatAclDataToLicenseId(userAclEntries: FormattedUserAclWithLicenseInfo): string {
    return userAclEntries.licenseId ?? '';
}
